<div *ngIf="codes && codes.length > 0" class="alert">
	<div *ngFor="let message of messages" class="error">
		<p>{{message}}</p>
	</div>
</div>